module.exports = __webpack_public_path__ + "assets/img/form2.9455e121.png";